module.exports = __webpack_public_path__ + "static/img/wechart.e8c6d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechart.png
// module id = d/PD
// module chunks = 0